import { c as _c } from "react/compiler-runtime";
import { m } from 'framer-motion';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { fShortenNumber } from 'src/utils/format-number';
import { useCheckoutContext } from 'src/sections/checkout/context';
import { Iconify } from '../iconify';
import { varTap, varHover, transitionTap } from '../animate';

// ----------------------------------------------------------------------

export function ButtonAddToCart(t0) {
  const $ = _c(46);
  let hideTotal;
  let other;
  let preview;
  let product;
  let sx;
  if ($[0] !== t0) {
    ({
      product,
      preview,
      hideTotal,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = hideTotal;
    $[2] = other;
    $[3] = preview;
    $[4] = product;
    $[5] = sx;
  } else {
    hideTotal = $[1];
    other = $[2];
    preview = $[3];
    product = $[4];
    sx = $[5];
  }
  const {
    onAddToCart
  } = useCheckoutContext();
  let t1;
  if ($[6] !== onAddToCart || $[7] !== product.available || $[8] !== product.card || $[9] !== product.cod || $[10] !== product.colors[0] || $[11] !== product.country || $[12] !== product.coverUrl || $[13] !== product.id || $[14] !== product.name || $[15] !== product.numberFormat || $[16] !== product.priceSale || $[17] !== product.sellerID || $[18] !== product.shipping || $[19] !== product.sizes[0] || $[20] !== product.sku || $[21] !== product.transaction) {
    t1 = () => onAddToCart({
      quantity: 1,
      id: product.id,
      cod: product.cod,
      sku: product.sku,
      card: product.card,
      name: product.name,
      country: product.country,
      coverUrl: product.coverUrl,
      sellerID: product.sellerID,
      shipping: product.shipping,
      available: product.available,
      priceSale: product.priceSale,
      size: [product.sizes[0] ?? ""],
      transaction: product.transaction,
      colors: [product.colors[0] ?? ""],
      numberFormat: product.numberFormat
    });
    $[6] = onAddToCart;
    $[7] = product.available;
    $[8] = product.card;
    $[9] = product.cod;
    $[10] = product.colors[0];
    $[11] = product.country;
    $[12] = product.coverUrl;
    $[13] = product.id;
    $[14] = product.name;
    $[15] = product.numberFormat;
    $[16] = product.priceSale;
    $[17] = product.sellerID;
    $[18] = product.shipping;
    $[19] = product.sizes[0];
    $[20] = product.sku;
    $[21] = product.transaction;
    $[22] = t1;
  } else {
    t1 = $[22];
  }
  const handleAddCart = t1;
  let t2;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      textAlign: "center",
      color: "common.white",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, .24))"
    };
    $[23] = t2;
  } else {
    t2 = $[23];
  }
  let t3;
  if ($[24] !== sx) {
    t3 = Array.isArray(sx) ? sx : [sx];
    $[24] = sx;
    $[25] = t3;
  } else {
    t3 = $[25];
  }
  let t4;
  if ($[26] !== t3) {
    t4 = [t2, ...t3];
    $[26] = t3;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  let t5;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = varTap();
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  let t6;
  let t7;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = varHover(1.08);
    t7 = transitionTap();
    $[29] = t6;
    $[30] = t7;
  } else {
    t6 = $[29];
    t7 = $[30];
  }
  let t8;
  if ($[31] !== handleAddCart || $[32] !== preview || $[33] !== product.available) {
    t8 = () => !preview && product.available && handleAddCart();
    $[31] = handleAddCart;
    $[32] = preview;
    $[33] = product.available;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Iconify icon="solar:cart-plus-bold" sx={{
      width: {
        xs: 32,
        md: 26
      },
      height: {
        xs: 32,
        md: 26
      }
    }} />;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== other || $[37] !== t8) {
    t10 = <IconButton size="small" color="inherit" whileTap={t5} component={m.button} whileHover={t6} transition={t7} onClick={t8} {...other}>{t9}</IconButton>;
    $[36] = other;
    $[37] = t8;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== hideTotal || $[40] !== product.totalSales) {
    t11 = !hideTotal && <Box sx={{
      typography: "caption"
    }}>{fShortenNumber(product.totalSales)}</Box>;
    $[39] = hideTotal;
    $[40] = product.totalSales;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== t10 || $[43] !== t11 || $[44] !== t4) {
    t12 = <Box sx={t4}>{t10}{t11}</Box>;
    $[42] = t10;
    $[43] = t11;
    $[44] = t4;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  return t12;
}